import { useState } from 'react';

import { useEffectOnce } from 'usehooks-ts';

import { apiGetCheckoutData, apiGetCheckoutDataWithPaymentMethod } from '../constants';
import useFetch from './useFetch';

const useFetchCheckoutData = cartId => {
  const [fetchUrl, setFetchUrl] = useState(null);
  const { data, status } = useFetch(fetchUrl);

  useEffectOnce(() => {
    if (cartId == null) return;
    setFetchUrl(apiGetCheckoutData(cartId));
  });

  const getDynamicCheckoutData = paymentMethod => {
    setFetchUrl(apiGetCheckoutDataWithPaymentMethod(cartId, paymentMethod));
  };

  return { checkoutData: data, checkoutDataStatus: status, getDynamicCheckoutData };
};

export default useFetchCheckoutData;
